import DossierContext from '@/dossier/models/DossierContext';
import { isPresent } from '@/shared/utils/typescript';
import Vehicle from '@/vehicle/models/Vehicle';
import DossierContact from '@/contact/models/DossierContact';
import { CheckInSettings, SignableDocument, UpsellItemId } from '@/dossier/models/CheckInDetails';
import VehicleData from '@/vehicle/models/VehicleData';
import JobContext from '@/jobs/models/JobContext';
import AbstractContext from '@/shared/models/AbstractContext';

export interface CheckInFormData extends VehicleData {
    contact: DossierContact | null;
    communicationPreference: string;
    refillLiquids: boolean;
    replacementVehicle: Vehicle | null;
    hasConsumptionDataApproval: boolean;
    confirmedByUser: boolean;
    selectedUpsellItemIds: Array<UpsellItemId>;
    signature: string | null;
    signedDocuments: Array<SignableDocument>;
}

export default class CheckInContext extends AbstractContext {
  readonly editableJobContext: JobContext;
  readonly formData: CheckInFormData = {
    contact: null,
    communicationPreference: '',
    mileage: null,
    isVerifiedMileage: false,
    countryId: null,
    hasMaps: false,
    locationDescription: '',
    position: null,
    keyLabel: '',
    refillLiquids: true,
    replacementVehicle: null,
    hasConsumptionDataApproval: true,
    confirmedByUser: true,
    selectedUpsellItemIds: [],
    signature: null,
    signedDocuments: [],
  };

  constructor(readonly dossierContext: DossierContext, readonly settings: CheckInSettings) {
    const vehicle = dossierContext.dossierVehicle.vehicle;

    super();
    this.formData.contact = dossierContext.contactContext.getPrimary() ?? null;
    this.formData.communicationPreference = dossierContext.dossier.communicationPreference ?? '';
    this.formData.mileage = vehicle.mileage;
    this.formData.isVerifiedMileage = vehicle.isVerifiedMileage ?? false;
    this.formData.countryId = vehicle.countryId ?? null;
    this.formData.hasMaps = isPresent(vehicle.location?.coordinates);
    this.formData.locationDescription = vehicle.location?.description ?? null;
    this.formData.position = vehicle.location?.coordinates ?? null;
    this.formData.keyLabel = vehicle.keyLabel?.content ?? '';

    this.editableJobContext = dossierContext.jobContext.createEditContext(); // Needed for the editable order status on checkin page
  }
}